var map = {
	"./international.de-CH.json": 1668,
	"./international.de-DE.json": 1669,
	"./international.en-CA.json": 1670,
	"./international.en-GB.json": 1671,
	"./international.en-IN.json": 1672,
	"./international.en-ME.json": 1673,
	"./international.en-US.json": 1674,
	"./international.es-EM.json": 1675,
	"./international.es-ES.json": 1676,
	"./international.fr-BE.json": 1677,
	"./international.fr-CA.json": 1678,
	"./international.fr-CH.json": 1679,
	"./international.nl-BE.json": 1680,
	"./international.nl-NL.json": 1681,
	"./international.pl-PL.json": 1682,
	"./international.pt-BR.json": 1683
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1667;